import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuthGuard, PrepareGuard } from 'app/core/core.module';
import { PendingChangesGuard } from 'app/core/pending-changes.guard';
import { SharedModule } from 'app/shared/shared.module';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { InvoiceOverviewComponent } from './invoice-overview/invoice-overview.component';
import { InvoiceLineDialogComponent } from './invoice-line-dialog/invoice-line-dialog.component';
import { LoadOverviewComponent } from 'app/customer/load-overview/load-overview.component';
import { PaymentOverviewComponent } from './payment-overview/payment-overview.component';
import { PaymentDetailComponent } from './payment-detail/payment-detail.component';
import { LoadHistoryComponent } from './load-history/load-history.component';
import { InvoiceHistoryComponent } from './invoice-history/invoice-history.component';



@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'invoices',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    { path: 'loads', component: LoadOverviewComponent, data: { title: 'Loads' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'load-history', component: LoadHistoryComponent, data: { title: 'Load History' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'overview', component: InvoiceOverviewComponent, data: { title: 'Invoices' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'history', component: InvoiceHistoryComponent, data: { title: 'Invoice History' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'payments', component: PaymentOverviewComponent, data: { title: 'Payments' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: ':id', component: InvoiceDetailComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                ],
            },
            {
                path: 'payments',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    { path: 'overview', component: PaymentOverviewComponent, data: { title: 'Payments' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: ':id', component: PaymentDetailComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                    {
                        path: ':id/:customerId/:selectedInvoiceId',
                        component: PaymentDetailComponent,
                        data: { title: 'Payment' },
                        canDeactivate: [PendingChangesGuard]
                    },
                ],
            },
        ]),
    ],
    declarations: [
        InvoiceOverviewComponent,
        InvoiceDetailComponent,
        InvoiceLineDialogComponent,
        PaymentOverviewComponent,
        PaymentDetailComponent,
        LoadHistoryComponent,
        InvoiceHistoryComponent
    ]
})
export class InvoicesModule {}
